import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import AuthPage from '../components/layout/AuthPage';

const MagicLinkVerify = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Invalid magic link - no token provided');
      return;
    }

    setStatus('success');
    setMessage('Email verified! Redirecting to password setup...');

    const timeout = setTimeout(() => {
      navigate(`/set-password?token=${token}`, { replace: true });
    }, 1500);

    return () => clearTimeout(timeout);
  }, [searchParams, navigate]);

  return (
    <AuthPage wide>
      <h1 className="auth-card__title">Verifying Magic Link</h1>

      {status === 'verifying' && (
        <div className="text-center">
          <Spinner animation="border" className="mb-3" />
          <p className="auth-card__subtitle mb-0">Please wait while we verify your magic link...</p>
        </div>
      )}

      {status === 'success' && (
        <Alert variant="success" className="mb-0">
          <h5 className="mb-2">Success!</h5>
          <p className="mb-0">{message}</p>
        </Alert>
      )}

      {status === 'error' && (
        <Alert variant="danger" className="mb-0">
          <h5 className="mb-2">Verification Failed</h5>
          <p>{message}</p>
          <p className="mb-0">
            <Link to="/app" className="auth-link">Try logging in again</Link>
            {' or '}
            <Link to="/register" className="auth-link">register for a new account</Link>
          </p>
        </Alert>
      )}
    </AuthPage>
  );
};

export default MagicLinkVerify;